/**
 * Origem Flow: serviço da página Início — endpoint /api/home/* do backend.
 */
export default (client) => {
  return {
    fetchAssignedRows(workspaceId, { limit = 100 } = {}) {
      return client.get(`/home/assigned/workspace/${workspaceId}/`, {
        params: { limit },
      })
    },
    fetchAllTasks(workspaceId, { mine = false } = {}) {
      return client.get(`/home/tasks/workspace/${workspaceId}/`, {
        params: mine ? { mine: 1 } : {},
      })
    },
    fetchAgendaRows(workspaceId, { from, to, mine = false } = {}) {
      return client.get(`/home/agenda/workspace/${workspaceId}/`, {
        params: { from, to, ...(mine ? { mine: 1 } : {}) },
      })
    },
    // Tabela "Todas as tarefas" (espelho agregado do espaço): GET só lê os
    // metadados; POST garante que existe e reconcilia com as tabelas de origem.
    fetchAllTasksMirror(workspaceId) {
      return client.get(`/home/all-tasks/workspace/${workspaceId}/`)
    },
    ensureAllTasksMirror(workspaceId) {
      return client.post(`/home/all-tasks/workspace/${workspaceId}/`)
    },
    fetchTableCounts(workspaceId) {
      return client.get(`/home/table-counts/workspace/${workspaceId}/`)
    },
    fetchFavoriteTables() {
      return client.get('/home/favorites/')
    },
    toggleFavoriteTable(tableId) {
      return client.post('/home/favorites/', { table_id: tableId })
    },
  }
}
